import { tns } from 'tiny-slider';
var ImageSliderBlock = /** @class */ (function () {
    function ImageSliderBlock(element) {
        this.imageSliderBlock = element;
        this.sliderContainer = this.imageSliderBlock.querySelector('.image-slider-wrapper');
        this.sliderCounter = this.imageSliderBlock.querySelector('.image-slider-count');
        this.currentSlideWrapper = this.sliderCounter.querySelector('p span:first-child');
        this.totalSlidesWrapper = this.sliderCounter.querySelector('p span:last-child');
        if (this.sliderContainer.childElementCount > 0) {
            // Check if slider contains any elements - initiate slider
            this.initSlider();
        }
    }
    ImageSliderBlock.prototype.initSlider = function () {
        this.tinySlider = tns({
            container: this.sliderContainer,
            items: 1,
            slideBy: 1,
            loop: false,
            autoplay: false,
            controls: true,
            nav: true,
            mouseDrag: true,
            swipeAngle: false,
            speed: 400,
        });
        // Set total count of slides
        this.totalSlidesWrapper.innerText = this.tinySlider.getInfo().slideCount;
        // Set initial current slide
        this.currentSlideWrapper.innerText = String(this.tinySlider.getInfo().index + 1);
        this.addEventListeners();
    };
    ImageSliderBlock.prototype.addEventListeners = function () {
        var _this = this;
        this.tinySlider.events.on('transitionEnd', function (event) { return _this.currentSlideWrapper.innerText = String(_this.tinySlider.getInfo().index + 1); });
    };
    return ImageSliderBlock;
}());
var imageSliderBlocks = document.querySelectorAll('[data-image-slider-block]');
imageSliderBlocks.forEach(function (sliderBlock) {
    new ImageSliderBlock(sliderBlock);
});
